import Icon from '../components/Icon.vue'

Icon.register({"object-ungroup":{"width":576,"height":512,"paths":[{"d":"M64 320V346A6-6 0 0 0 58 352H6A6-6 0 0 0 0 346V294A6-6 0 0 0 6 288H32V96H6A6-6 0 0 0 0 90V38A6-6 0 0 0 6 32H58A6-6 0 0 0 64 38V64H352V38A6-6 0 0 0 358 32H410A6-6 0 0 0 416 38V90A6-6 0 0 0 410 96H384V288H410A6-6 0 0 0 416 294V346A6-6 0 0 0 410 352H358A6-6 0 0 0 352 346V320H64zM544 256V224H570A6-6 0 0 1 576 218V166A6-6 0 0 1 570 160H518A6-6 0 0 1 512 166V192H408V264H416C429.3 264 440 274.7 440 288V352C440 365.3 429.3 376 416 376H352C338.7 376 328 365.3 328 352V344H192V416H166A6-6 0 0 1 160 422V474A6-6 0 0 1 166 480H218A6-6 0 0 1 224 474V448H512V474A6-6 0 0 1 518 480H570A6-6 0 0 1 576 474V422A6-6 0 0 1 570 416H544V256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/object-ungroup.js
// module id = hOf7
// module chunks = 0